export default __webpack_public_path__ + "static/media/computer_course.5b89c160.jpg";